export default __webpack_public_path__ + "static/media/default-profile.697fdcd2.png";